var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H9.42857V7.46667H0V0Z",
    fill: "#1A47B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42857 0V1.06667H22V0H9.42857ZM9.42857 2.13333V3.2H22V2.13333H9.42857ZM9.42857 4.26667V5.33333H22V4.26667H9.42857ZM9.42857 6.4V7.46667H22V6.4H9.42857ZM0 8.53333V9.6H22V8.53333H0ZM0 10.6667V11.7333H22V10.6667H0ZM0 12.8V13.8667H22V12.8H0ZM0 14.9333V16H22V14.9333H0Z",
    fill: "#F93939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04761 1.06665V2.13332H2.09523V1.06665H1.04761ZM3.14285 1.06665V2.13332H4.19046V1.06665H3.14285ZM5.23808 1.06665V2.13332H6.2857V1.06665H5.23808ZM7.33332 1.06665V2.13332H8.38094V1.06665H7.33332ZM6.2857 2.13332V3.19998H7.33332V2.13332H6.2857ZM4.19046 2.13332V3.19998H5.23808V2.13332H4.19046ZM2.09523 2.13332V3.19998H3.14285V2.13332H2.09523ZM1.04761 3.19998V4.26665H2.09523V3.19998H1.04761ZM3.14285 3.19998V4.26665H4.19046V3.19998H3.14285ZM5.23808 3.19998V4.26665H6.2857V3.19998H5.23808ZM7.33332 3.19998V4.26665H8.38094V3.19998H7.33332ZM1.04761 5.33332V6.39998H2.09523V5.33332H1.04761ZM3.14285 5.33332V6.39998H4.19046V5.33332H3.14285ZM5.23808 5.33332V6.39998H6.2857V5.33332H5.23808ZM7.33332 5.33332V6.39998H8.38094V5.33332H7.33332ZM6.2857 4.26665V5.33332H7.33332V4.26665H6.2857ZM4.19046 4.26665V5.33332H5.23808V4.26665H4.19046ZM2.09523 4.26665V5.33332H3.14285V4.26665H2.09523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/usa-flag.4cbe55f3ae3a2653980cee287bc0bc57.svg";
export { ForwardRef as ReactComponent };